import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import WpBlogPostPreview from '../WpBlogPostPreview'

import {
  ousterBlogRelatedPosts,
  ousterBlogRelatedPostsContainer,
} from './index.module.css'

import { getRelated } from '../../utils/index.js'

const WPBlogRelatedPosts = ({ relatedData, defaultdata, location, data }) => {
  const [relatedPosts, setRelatedPosts] = useState([])
  const intl = useIntl()
  const blogRelatedHeader = intl.formatMessage({
    id: 'blog.relatedArticlesHeader',
  })
  useEffect(() => {
    setRelatedPosts(getRelated(relatedData, data))
  }, [])
  return (
    <div className={ousterBlogRelatedPostsContainer}>
      {relatedPosts.length > 0 && (
        <>
          <h3>{blogRelatedHeader}</h3>
          <div className={ousterBlogRelatedPosts}>
            {relatedPosts.map(({ node }) => {
              return (
                <WpBlogPostPreview
                  data={node}
                  defaultdata={defaultdata}
                  key={node.id}
                  location={location}
                />
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default WPBlogRelatedPosts
